import React, { createContext, useContext, useState, useCallback } from "react";

/**
 * Filtros de prospección COMPARTIDOS entre la lista (Prospección), el Mapa y el
 * Inicio del comercial. Así, tocar un estado del pipeline en el Inicio filtra
 * tanto la tabla como el mapa, y cambiar de pestaña conserva los filtros.
 */
const DEFAULT_FILTERS = {
  barrio: "",
  estado: "",     // régimen PH (ph_en_tramite / ph_incorporado / comun)
  vis: false,     // solo Vivienda Promovida
  minScore: 0,
  crm: "",        // estado del pipeline CRM
  sinAdmin: false, // excluir ya administrados
  obra: "",       // permiso5 / permiso / sinpermiso
};

const Ctx = createContext(null);

export function ProspeccionFilterProvider({ children }) {
  const [filters, setFiltersState] = useState(DEFAULT_FILTERS);
  const setFilter = useCallback((key, value) => setFiltersState((f) => ({ ...f, [key]: value })), []);
  const setFilters = useCallback((obj) => setFiltersState((f) => ({ ...f, ...obj })), []);
  const resetFilters = useCallback(() => setFiltersState(DEFAULT_FILTERS), []);
  // Deja todos los filtros salvo el CRM en su estado por defecto, y setea el CRM
  // pedido (para el click desde el pipeline del Inicio).
  const soloCrm = useCallback((estadoCrm) => setFiltersState({ ...DEFAULT_FILTERS, crm: estadoCrm }), []);
  return (
    <Ctx.Provider value={{ filters, setFilter, setFilters, resetFilters, soloCrm }}>
      {children}
    </Ctx.Provider>
  );
}

export function useProspeccionFilters() {
  return useContext(Ctx) || {
    filters: DEFAULT_FILTERS,
    setFilter: () => {},
    setFilters: () => {},
    resetFilters: () => {},
    soloCrm: () => {},
  };
}
